import type { RouteObject } from 'react-router'
import { AppShell } from '@/components/layout/AppShell'
import { LoginPage } from '@/features/auth/LoginPage'
import { PendingPage } from '@/features/auth/PendingPage'
import { RegisterPage } from '@/features/auth/RegisterPage'
import { TwoFactorChallengePage } from '@/features/auth/TwoFactorChallengePage'
import { RedirectWhenSignedIn, RequireApproved, RequireSession } from '@/features/auth/guards'
import { NotFound } from '@/routes/NotFound'
import { RouteError } from '@/routes/RouteError'
import { RouteFallback } from '@/routes/RouteFallback'

export const routes: RouteObject[] = [
  {
    Component: RedirectWhenSignedIn,
    ErrorBoundary: RouteError,
    HydrateFallback: RouteFallback,
    children: [
      { path: '/login', Component: LoginPage },
      { path: '/login/2fa', Component: TwoFactorChallengePage },
      { path: '/register', Component: RegisterPage },
    ],
  },
  {
    path: '/',
    Component: RequireSession,
    ErrorBoundary: RouteError,
    HydrateFallback: RouteFallback,
    children: [
      {
        Component: AppShell,
        children: [
          { path: 'pending', Component: PendingPage },
          {
            path: 'security',
            lazy: async () => ({
              Component: (await import('@/features/auth/TwoFactorSetupPage')).TwoFactorSetupPage,
            }),
          },
          {
            path: 'sdk',
            handle: { section: 'nav.sdk' },
            lazy: async () => ({ Component: (await import('@/features/sdk/SdkPage')).SdkPage }),
          },
          {
            path: 'faq',
            handle: { section: 'nav.faq' },
            lazy: async () => ({ Component: (await import('@/features/faq/FaqPage')).FaqPage }),
          },
          {
            Component: RequireApproved,
            children: [
              {
                index: true,
                handle: { section: 'nav.dashboard' },
                lazy: async () => ({
                  Component: (await import('@/routes/DashboardPage')).DashboardPage,
                }),
              },
              {
                path: 'statistics',
                handle: { section: 'nav.statistics' },
                lazy: async () => ({
                  Component: (await import('@/features/statistics/StatisticsPage')).StatisticsPage,
                }),
              },
              {
                path: 'moderation',
                handle: { section: 'nav.moderation' },
                lazy: async () => ({
                  Component: (await import('@/features/moderation/ModerationPage')).ModerationPage,
                }),
              },
              {
                path: 'plugin',
                handle: { section: 'nav.plugin' },
                lazy: async () => ({
                  Component: (await import('@/features/plugin/PluginPage')).PluginPage,
                }),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/styleguide',
    ErrorBoundary: RouteError,
    HydrateFallback: RouteFallback,
    lazy: async () => ({ Component: (await import('@/routes/StyleGuide')).StyleGuide }),
  },
  { path: '*', Component: NotFound },
]
